import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {AppStateService} from 'src/app/core-module/services/app-state.service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {ReadDeviceComponent} from '../read-device/read-device.component';
import {Subscription} from "rxjs";
import {FEATURE_NORMALIZATION} from 'src/app/shared-module/constants/supported-features-constant';
import { AvailableFeaturesStateService } from "../../../core-module/services/state/available-features-state.service";
import { CorruptFeaturesService } from "../../../core-module/services/state/corrupt-features.service";
import { DeviceConfigStateService } from "../../../core-module/services/state/device-config-state.service";
import { UiSignalsStateService } from "../../../core-module/services/state/ui-signals-state.service";

@Component({
  standalone: false,
  selector: 'app-read-default-values-popup',
  templateUrl: './read-default-values-popup.component.html',
  styleUrls: ['./read-default-values-popup.component.scss'],
})
export class ReadDefaultValuesPopupComponent implements OnInit, OnDestroy {
  isWritingPopup: boolean=false;
  isboxconfiguredprocess: boolean = false;
  isboxreaderconnected: boolean = false;
  @Input() public data;
  unsupportedFeaturesConfirmButton: boolean = false;
  unsupportedFeatures: string[] = [];
  unsupportedCorruptPresent: boolean = false;
  countOrangereen = 0;
  modalTitle: string = "Incorrectly configured devices found";
  modalMessage: string = "System will proceed with partially read values if features are partially read or will proceed with default values if features are not read at all.";
  cnfBtnClicked: boolean = false;
  private featuresSub: Subscription;
  constructor(
    public activemodal: NgbActiveModal, public route:Router, private modalService: NgbModal, private appState: AppStateService,
    private corruptFeatures: CorruptFeaturesService,
    private uiSignals: UiSignalsStateService,
    private deviceConfig: DeviceConfigStateService,
    private availFeat: AvailableFeaturesStateService
  ) { }

  ngOnInit() {
    this.initializeWritingPopup();
    this.initializeReaderConnection();
    this.subscribeToUnsupportedFeatures();
    this.processCorruptedFeatures();
    this.setModalContent();
  }

  private initializeWritingPopup(): void {
    if (this.appState.getIsWriting()) {
      this.isWritingPopup = true;
    }
  }

  private initializeReaderConnection(): void {
    const detectedReaderInfo = this.appState.getDetectedReaderInfo();
    if (detectedReaderInfo && detectedReaderInfo.selectedReader) {
      const boxreaderconnected = detectedReaderInfo.selectedReader.peripheralType;
      if (boxreaderconnected === 'LCN9640') {
        this.isboxreaderconnected = true;
      }
    }
  }

  private subscribeToUnsupportedFeatures(): void {
    this.featuresSub = this.corruptFeatures.getFilteredNotSupportedCorruptFeatures().subscribe(features => {
      this.unsupportedFeatures = features;
    });
  }

  private processCorruptedFeatures(): void {
    this.countOrangereen = 0;
    let corruptedFeatures = ' ';

    this.data.forEach((element) => {
      if (typeof element === 'object' && element !== null && 'flag' in element) {
        if (element["flag"] === "orange" || element["flag"] === "red" || element["flag"] === "unsupported") {
          corruptedFeatures += element["name"] + ',';
          this.countOrangereen++;
          if (element["flag"] === 'unsupported') {
            this.unsupportedCorruptPresent = true;
          }
        }
      } else {
        corruptedFeatures += element + ',';
        this.countOrangereen++;
        this.isboxconfiguredprocess = true;
      }
    });

    if (this.countOrangereen == 0) {
      this.data.forEach((element) => {
        corruptedFeatures = corruptedFeatures + element + ',';
        this.countOrangereen++;
      });
    }
  }

  private setModalContent(): void {
    if (this.countOrangereen > 0 || this.unsupportedFeatures.length !== 0 || this.unsupportedCorruptPresent) {
      const corruptedFeatures = this.getFormattedCorruptedFeatures();
      const deviceDataLength = Number(this.appState.getDeviceDataLength());
      const corruptedDevicesCount = Number(this.appState.getCorruptedDevicesCount());

      this.setModalTitle(deviceDataLength);
      this.setModalMessage(deviceDataLength, corruptedDevicesCount, corruptedFeatures);
    }
  }

  private getFormattedCorruptedFeatures(): string {
    let corruptedFeatures = ' ';
    this.data.forEach((element) => {
      if (typeof element === 'object' && element !== null && 'flag' in element) {
        if (element["flag"] === "orange" || element["flag"] === "red" || element["flag"] === "unsupported") {
          corruptedFeatures += element["name"] + ',';
        }
      } else {
        corruptedFeatures += element + ',';
      }
    });
    return corruptedFeatures.substring(0, corruptedFeatures.length - 1) + ' ';
  }

  private setModalTitle(deviceDataLength: number): void {
    const isNormalReader = !this.isboxreaderconnected && !this.isboxconfiguredprocess;
    const isBoxProcess = this.isboxconfiguredprocess && this.isboxreaderconnected;
    const titleSuffix = (isNormalReader && !isBoxProcess) || (this.isboxreaderconnected && deviceDataLength === 1 && !this.isboxconfiguredprocess) ? "device" : "devices";
    this.modalTitle = `Incorrectly configured ${titleSuffix} found`;
  }

  private setModalMessage(deviceDataLength: number, corruptedDevicesCount: number, corruptedFeatures: string): void {
    const isNormalReader = !this.isboxreaderconnected && !this.isboxconfiguredprocess;
    const isBoxProcess = this.isboxconfiguredprocess && this.isboxreaderconnected;
    const hasUnsupported = (this.unsupportedFeatures?.length ?? 0) > 0 || this.unsupportedCorruptPresent;

    if (isNormalReader && !isBoxProcess || (this.isboxreaderconnected && deviceDataLength === 1 && !this.isboxconfiguredprocess)) {
      this.handleSingleDeviceMessage(hasUnsupported, corruptedFeatures);
    } else if (this.isboxreaderconnected && this.unsupportedCorruptPresent) {
      this.handleBoxReaderUnsupportedMessage(corruptedDevicesCount, deviceDataLength);
    } else if (this.unsupportedFeatures?.length > 0) {
      this.handleUnsupportedFeaturesMessage(corruptedDevicesCount, deviceDataLength);
    } else {
      this.handleMultipleDevicesMessage(isBoxProcess, corruptedDevicesCount, deviceDataLength, corruptedFeatures);
    }
  }

  private handleSingleDeviceMessage(hasUnsupported: boolean, corruptedFeatures: string): void {
    this.unsupportedFeaturesConfirmButton = false;
    this.modalMessage = hasUnsupported
      ? "Device found which has incorrectly configured feature(s) \n Some of these features are not supported in MultiOne Web.\n Use MultiOne Engineering to repair configuration for these features. \n Please cancel reading or continue with default feature parameters for \n the supported incorrectly configured features"
      : `Device found which has incorrectly configured feature(s): ${corruptedFeatures}\nPlease cancel reading or continue with default feature parameters for these features`;
  }

  private handleBoxReaderUnsupportedMessage(corruptedDevicesCount: number, deviceDataLength: number): void {
    this.unsupportedFeaturesConfirmButton = false;
    this.modalMessage = `${corruptedDevicesCount} out of ${deviceDataLength} devices found which have incorrectly configured feature(s) \n Some of these features are not supported in MultiOne Web.\nUse MultiOne Engineering to repair configuration for these features. \n Please cancel reading or continue`;
  }

  private handleUnsupportedFeaturesMessage(corruptedDevicesCount: number, deviceDataLength: number): void {
    this.unsupportedFeaturesConfirmButton = true;
    this.modalMessage = `${corruptedDevicesCount} out of ${deviceDataLength} devices found which have incorrectly configured feature(s)\nSome of these features are not supported in MultiOne Web.\nPlease use MultiOne Engineering to repair configuration for these features`;
  }

  private handleMultipleDevicesMessage(isBoxProcess: boolean, corruptedDevicesCount: number, deviceDataLength: number, corruptedFeatures: string): void {
    this.unsupportedFeaturesConfirmButton = false;
    this.modalMessage = isBoxProcess
      ? `${corruptedDevicesCount} out of ${deviceDataLength} devices found which have incorrectly configured feature(s): ${corruptedFeatures}\nPlease reconfigure the box for these features`
      : `${corruptedDevicesCount} out of ${deviceDataLength} devices found which have incorrectly configured feature(s): ${corruptedFeatures}\nPlease cancel reading or continue with default feature parameters for these features`;
  }


  cancel() {
    this.activemodal.close();
    this.uiSignals.modalClose('close');
  }
  confirm() {
    this.deviceConfig.setCnfBtnClicked(true);

    // Extract corrupted features and pass to ApiService
    this.extractAndPassCorruptedFeatures();

    this.activemodal.close();
  }

  private extractAndPassCorruptedFeatures(): void {
    // Get list of corrupted feature names (display names) - only orange or red flags
    const corruptedFeatures: string[] = [];

    for (const element of this.data) {
      let featureName = '';
      let isCorrupted = false;

      if (typeof element === 'object' && element !== null && 'name' in element) {
        featureName = element.name;
        // Only include features with orange or red flags (actual corruption)
        if (element["flag"] === "orange" || element["flag"] === "red") {
          isCorrupted = true;
        }
      } else if (typeof element === 'string') {
        // If it's a string (from box configured process), include it
        featureName = element;
        isCorrupted = true;
      }

      if (featureName && isCorrupted) {
        corruptedFeatures.push(featureName);
      }
    }

    // Pass to ApiService so feature-supported component can handle it
    this.corruptFeatures.setCorruptedFeaturesNeedingDefaults(corruptedFeatures);

    // Remove corrupted features from configurationData.resp and saveReadValue
    // so default values can take effect on next read.
    this.removeCorruptedFeaturesFromStorage(corruptedFeatures);
  }

  /**
   * Build a set of lowercase tokens that identify the corrupted features.
   * A storage key (e.g. "TouchDim", "LumInfoFormat", "DCEmergency",
   * "DiiA253Maintenance", "DaliAddressing102") is matched simply by lowercasing
   * it and checking membership in this set, so no hard-coded alias table is
   * required.
   *
   * Tokens for a display name come from:
   *   1. All FEATURE_NORMALIZATION entries whose value === displayName
   *      (e.g. "Luminaire Info" -> "luminaire info", "luminfoformat")
   *   2. The display name itself, lowercased and with whitespace removed
   *      (e.g. "DC Emergency" -> "dcemergency", "Touch Dim" -> "touchdim")
   */
  private buildCorruptedTokenSet(corruptedDisplayNames: string[]): Set<string> {
    const tokens = new Set<string>();

    // Invert FEATURE_NORMALIZATION on the fly
    const displayToTokens: { [display: string]: string[] } = {};
    for (const token of Object.keys(FEATURE_NORMALIZATION)) {
      const display = FEATURE_NORMALIZATION[token];
      (displayToTokens[display] = displayToTokens[display] || []).push(token);
    }

    for (const displayName of corruptedDisplayNames) {
      // Always include the display name itself, normalized
      tokens.add(displayName.toLowerCase().replace(/\s+/g, ''));
      // Plus every lowercase token mapped to this display name
      const mapped = displayToTokens[displayName] || [];
      for (const t of mapped) {
        tokens.add(t.toLowerCase().replace(/\s+/g, ''));
      }
    }
    return tokens;
  }

  /**
   * Delete entries from `target` whose key (case/space-insensitive) is in
   * `tokens`. Returns the keys that were removed.
   */
  private deleteMatchingKeys(target: Record<string, unknown>, tokens: Set<string>): void {
    if (!target || typeof target !== 'object') {
      return;
    }
    for (const existingKey of Object.keys(target)) {
      const norm = existingKey.toLowerCase().replace(/\s+/g, '');
      if (tokens.has(norm)) {
        delete target[existingKey];
      }
    }
  }

  private removeCorruptedFeaturesFromStorage(corruptedDisplayNames: string[]): void {
    if (!corruptedDisplayNames || corruptedDisplayNames.length === 0) {
      return;
    }

    const tokens = this.buildCorruptedTokenSet(corruptedDisplayNames);

    // 1. configurationData.resp
    const configData = this.appState.getConfigurationData();
    if (configData?.resp) {
      this.deleteMatchingKeys(configData.resp, tokens);
      this.appState.setConfigurationData(configData);
    }

    // 2. saveReadValue
    const saveReadValue = this.appState.getSaveReadValue();
    if (saveReadValue && typeof saveReadValue === 'object') {
      this.deleteMatchingKeys(saveReadValue, tokens);
      this.appState.setSaveReadValue(saveReadValue);
    }
  }

  confirmUnsupported() {
    this.deviceConfig.setCnfBtnClicked(false);
    this.activemodal.close();
  }
  selectreader() {
    this.cancel();
    this.appState.setNormalFlow(false);
    const navigation: LegacyAny = this.route.navigate(['/featureLanding']);
    if (navigation && typeof navigation.finally === 'function') {
      navigation.finally(() => {
        this.activemodal.close();
      });
      return;
    }
    this.activemodal.close();
  }

  retry() {
    this.activemodal.close();
    this.uiSignals.modalClose('close');
    this.availFeat.modalConfigurationData('readDevice');
    const modalRef = this.modalService.open(ReadDeviceComponent,{windowClass: 'select-feature-modal',backdropClass: "customBackdrop"});
  }

  ngOnDestroy() {
    if (this.featuresSub) {
      this.featuresSub.unsubscribe();
    }
    this.corruptFeatures.sendCorruptFeat('');
    this.corruptFeatures.sendNonCorrupt('');
    this.corruptFeatures.redFailedFeatures('');
    this.uiSignals.modalClose('');
    this.uiSignals.readerInfo('');
    this.availFeat.sendFeatures('');
    this.countOrangereen = 0;
  }
}
